(function(){
if(window.__aG)return;window.__aG=1;
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var pill,bar,txt,prev=null;
try{prev=JSON.parse(sessionStorage.getItem('aGprev'));}catch(e){}
function mk(){
  if(pill)return;
  pill=document.createElement('div');pill.className='aG-pill';pill.setAttribute('role','status');
  pill.innerHTML='<p></p><div class="aG-bar"><i></i></div>';
  document.body.appendChild(pill);txt=pill.querySelector('p');bar=pill.querySelector('i');
}
function confetti(){
  if(reduce)return;
  var c=['#C0582F','#E8B08F','#C9A24A','#4F5B2E','#F6DC9B'];
  for(var i=0;i<46;i++){
    var e=document.createElement('i');e.className='aG-conf';
    e.style.left=Math.random()*100+'vw';e.style.background=c[i%c.length];
    e.style.setProperty('--dx',(Math.random()*160-80)+'px');
    e.style.setProperty('--r',(Math.random()*720-360)+'deg');
    e.style.animationDuration=(1.6+Math.random()*1.4)+'s';
    e.style.animationDelay=(Math.random()*0.4)+'s';
    document.body.appendChild(e);
    (function(x){setTimeout(function(){x.remove();},3600);})(e);
  }
}
function render(n){
  mk();
  if(n<1){pill.classList.remove('on');}
  else{
    var left=Math.max(0,3-n);
    txt.textContent=left===0?'Bravo ! Le 3ᵉ soin est offert ✦':(left===1?'Plus qu’1 soin pour avoir le 3ᵉ offert !':'Plus que '+left+' soins pour avoir le 3ᵉ offert');
    bar.style.width=Math.min(100,Math.round(n/3*100))+'%';
    pill.classList.add('on');
  }
  if(prev!==null&&prev<3&&n>=3)confetti();
  prev=n;
  try{sessionStorage.setItem('aGprev',JSON.stringify(n));}catch(e){}
}
function refresh(){
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){render(c.item_count||0);}).catch(function(){});
}
function visible(el){var r=el.getBoundingClientRect();return r.width>0&&r.height>0;}
function cartTarget(){
  var l=document.querySelectorAll('cart-icon,#cart-icon,.aL-acts a[href*="/cart"],a[href$="/cart"]');
  for(var i=0;i<l.length;i++){if(visible(l[i]))return l[i];}
  return null;
}
function fly(btn){
  if(reduce)return;
  var t=cartTarget();if(!t)return;
  var scope=btn.closest('product-card,.product-card,product-component,.product-information,.product')||document.querySelector('main')||document;
  var img=scope.querySelector('img');
  var useImg=!!(img&&visible(img));
  var s=(useImg?img:btn).getBoundingClientRect();
  var d=t.getBoundingClientRect();
  var el=document.createElement(useImg?'img':'span');
  el.className='aG-fly'+(useImg?'':' aG-dot');
  if(useImg)el.src=img.currentSrc||img.src;
  var w=Math.min(s.width,140),h=useImg?Math.min(s.height,140):w;
  el.style.left=(s.left+s.width/2-w/2)+'px';el.style.top=(s.top+s.height/2-h/2)+'px';
  el.style.width=w+'px';el.style.height=h+'px';
  document.body.appendChild(el);
  var dx=d.left+d.width/2-(s.left+s.width/2),dy=d.top+d.height/2-(s.top+s.height/2);
  var a=el.animate([
    {transform:'translate(0,0) scale(1)',opacity:1},
    {transform:'translate('+(dx*0.5)+'px,'+(dy*0.5-80)+'px) scale(.6)',opacity:0.95,offset:0.55},
    {transform:'translate('+dx+'px,'+dy+'px) scale(.08)',opacity:0.2}
  ],{duration:850,easing:'cubic-bezier(.5,0,.3,1)'});
  a.onfinish=function(){el.remove();t.classList.remove('aG-bump');void t.offsetWidth;t.classList.add('aG-bump');};
}
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[name="add"],button[type="submit"],add-to-cart-component button');
  if(!b)return;
  var f=b.closest('form');
  var isAdd=b.matches('[name="add"],add-to-cart-component button')||(f&&/\/cart\/add/.test(f.getAttribute('action')||''));
  if(!isAdd||b.disabled||b.getAttribute('aria-disabled')==='true')return;
  fly(b);setTimeout(refresh,900);setTimeout(refresh,2000);
},true);
document.addEventListener('pointerdown',function(e){
  if(reduce)return;
  if(!e.target.closest||!e.target.closest('a,button,input[type=submit],label,.button'))return;
  var d=document.createElement('span');d.className='aG-drop';
  d.style.left=e.clientX+'px';d.style.top=e.clientY+'px';
  document.body.appendChild(d);setTimeout(function(){d.remove();},800);
},{passive:true});
var of=window.fetch;
if(of){window.fetch=function(){
  var p=of.apply(this,arguments);
  try{var a=arguments[0];var u=typeof a==='string'?a:((a&&a.url)||'');
    if(/\/cart\/(add|change|update|clear)/.test(u)){p.then(function(){setTimeout(refresh,250);}).catch(function(){});}
  }catch(e){}
  return p;
};}
['cart:update','cart:change','cart:refresh'].forEach(function(n){document.addEventListener(n,function(){setTimeout(refresh,250);});});
window.addEventListener('pageshow',refresh);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
})();